import { UseMutateFunction } from '@tanstack/react-query';

import {
	getExportActiveAlarmsFlexidas,
	getExportAlarmFile,
	getExportAlarmHistoryFile,
	getExportAlarmHistoryFlexidas,
	getExportOranAlarmFile,
	getExportOranHistoryAlarmFile,
} from '@api/exportAlarmHistory';

import { IAcknowledgeAlarmDTO, IAlarmByVendorExport } from '@interfaces/alarms/dto/alarmsDTO';
import { IId } from '@interfaces/common/common';

import { EVendorsValues } from '@enums/common';

import { useMutateClearAlarm } from '../useMutateClearAlarm';
import { useMutateExportAlarmFile } from '../useMutateExportAlarmHistoryFile';

import { useMutateAcknowledgeAlarmOran } from './useMutateAcknowledgeAlarmOran';
import { useMutateClearAlarmOran } from './useMutateClearAlarmOran';

interface IUseMutateActiveAlarmReturned {
	acknowledgeAlarm: UseMutateFunction<any, any, IAcknowledgeAlarmDTO, any>;
	clearAlarm: UseMutateFunction<any, any, IId, any>;
	handlePreparingExport: UseMutateFunction<any, any, IAlarmByVendorExport, any>;
	isLoadingAlarm: boolean;
}

const getExportRequest = (vendor: string, isActiveTab: boolean) => {
	switch (vendor) {
		case EVendorsValues.oran:
		case EVendorsValues.benetel:
			return isActiveTab ? getExportOranAlarmFile : getExportOranHistoryAlarmFile;
		case EVendorsValues.flexidas:
			return isActiveTab ? getExportActiveAlarmsFlexidas : getExportAlarmHistoryFlexidas;
		case EVendorsValues.limenet:
			return isActiveTab ? getExportAlarmFile : getExportAlarmHistoryFile;
		default:
			return getExportAlarmHistoryFile;
	}
};

export const useMutateActiveAlarm = ({
	vendor,
	isActiveTab,
	onSuccessClear,
	onSuccessAcknowledge,
}: {
	vendor: string;
	isActiveTab: boolean;
	onSuccessClear: () => void;
	onSuccessAcknowledge: () => void;
}): IUseMutateActiveAlarmReturned => {
	const {
		acknowledgeAlarm,
		isAcknowledgeAlarm,
	} = useMutateAcknowledgeAlarmOran({ onSuccess: onSuccessAcknowledge });

	const {
		clearOranAlarm,
		isLoadingClearOranAlarm,
	} = useMutateClearAlarmOran({ onSuccess: onSuccessClear });

	const { clearAlarm, isLoadingClearAlarm } = useMutateClearAlarm({
		onSuccess: onSuccessClear,
	});

	const {
		handlePreparingExport,
		isLoadingExportAlarmHistoryFile,
	} = useMutateExportAlarmFile(getExportRequest(vendor, isActiveTab));

	return {
		acknowledgeAlarm,
		clearAlarm: vendor === EVendorsValues.oran ? clearOranAlarm : clearAlarm,
		handlePreparingExport: handlePreparingExport,
		isLoadingAlarm: isLoadingClearAlarm ||
			isLoadingClearOranAlarm ||
			isLoadingExportAlarmHistoryFile ||
			isAcknowledgeAlarm,
	};
};
